import React from 'react';
import { GALLERY_PHOTOS } from '../data/sitePhotos';

export const PhotoGallerySection = () => (
  <section className="py-16 sm:py-20 bg-gray-50" aria-labelledby="gallery-heading">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10 max-w-3xl mx-auto">
        <h2 id="gallery-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
          Local Moves, Neighborhood by Neighborhood
        </h2>
        <p className="text-lg text-gray-600">
          From quiet suburban streets to busy apartment complexes, we show up ready to work.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
        {GALLERY_PHOTOS.map((photo) => (
          <figure key={photo.src} className="overflow-hidden rounded-xl shadow-sm">
            <img
              src={photo.src}
              alt={photo.alt}
              width={photo.width}
              height={photo.height}
              loading="lazy"
              decoding="async"
              className="h-44 sm:h-56 w-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </figure>
        ))}
      </div>
      <p className="mt-4 text-center text-xs text-gray-500">Images are illustrative.</p>
    </div>
  </section>
);
